import Snackbar from '@luminopia/react-toolbox/lib/snackbar'
import 'babel-polyfill'
import PrivateRoute from 'core/components/PrivateRoute'
import 'core/sentry'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {connect, Dispatch, Provider} from 'react-redux'
import {Route, RouteComponentProps, Router, Switch} from 'react-router'
import Dashboard from './components/dashboard/dashboard'
import history from './history'
import * as classNames from './main.css'
import * as Pages from './pages'
import * as routes from './routes'
import store, {extendTokenRequest, listenHeartbeatRequest, snackbarReset} from './store'
import {IState} from './store/reducer'
import safeSessionStorage from 'core/store/safe-session-storage'

interface IStateProps {
  isLoggedIn: boolean
  isHydrated: boolean
  snackbarIsActive: boolean
  snackbarLabel: string
}

interface IDispatchProps {
  onClickSnackbar: () => void
  onUserAction: () => void
  onMount: () => void
}

interface IOwnProps {
}

interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

class Main extends React.PureComponent<IProps, {}> {
  private removeSubscriptions: Array<() => void> = []

  public componentDidMount() {
    const selectedSubject = safeSessionStorage.get("selectedSubject");

    safeSessionStorage.clear();

    // If there was a selected subject, restore it
    // this is a little dirty but it enables a refresh of the individual subject page to work
    if (selectedSubject) {
      safeSessionStorage.set("selectedSubject", selectedSubject);
    }

    this.props.onMount();
    window.addEventListener('mousedown', this.props.onUserAction);
    const clearListener = () =>
      window.removeEventListener('mousedown', this.props.onUserAction);
    this.removeSubscriptions.push(clearListener);
  }

  public componentWillUnmount() {
    this.removeSubscriptions.forEach((removeFn) => removeFn())
  }

  public render(): React.ReactElement<{}> {
    const { isLoggedIn, isHydrated } = this.props

    if (!isHydrated) {
      return <div></div>
    }

    // TODO Snackbar I18N
    return (
      <Router history={history}>
        <div className={classNames.main}>
          <Switch>
            <Route path={routes.loginRoute()} component={Pages.LoginPage} />
            <Route path={routes.logoutRoute()} component={Pages.LogoutPage} />
            <Route path={routes.registerRoute()} component={Pages.RegisterPage} />
            <Route path={routes.createAccountRoute()} component={Pages.CreateAccountPage} />
            <Route path={routes.forgotPasswordRoute()} component={Pages.ForgotPasswordPage} />
            <Route path={routes.registerConfirmationRoute()} component={Pages.RegisterConfirmPage} />
            <PrivateRoute
              path={routes.rootRoute()}
              isAccessible={isLoggedIn}
              redirectTo={routes.loginRoute()}
              redirectState={(routeProps: RouteComponentProps<void>) => ({ from: routeProps.location })}
              render={(props) => (
                <Dashboard {...props} />
              )}
            />
          </Switch>

          <Snackbar
            action='Dismiss'
            onClick={this.props.onClickSnackbar}
            active={this.props.snackbarIsActive}
            label={this.props.snackbarLabel}
            type='cancel'
          />
        </div>
      </Router>
    )
  }
}

const mapStateToProps = (state: IState) => ({
  isLoggedIn: !!state.login.token,
  isHydrated: state.persist.isHydrated,
  snackbarIsActive: state.main.snackbar.isActive,
  snackbarLabel: state.main.snackbar.label,
})
const mapDispatchToProps = (dispatch: Dispatch<void>) =>  ({
  onClickSnackbar: () => dispatch(snackbarReset()),
  onUserAction: () => dispatch(extendTokenRequest()),
  onMount: () => dispatch(listenHeartbeatRequest()),
})
const ConnectedMain = connect<IStateProps, IDispatchProps, {}, IState>(mapStateToProps, mapDispatchToProps)(Main)

ReactDOM.render(
  <Provider store={store}>
    <ConnectedMain />
  </Provider>,
  document.getElementById('app'),
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/main.tsx